module.exports = __webpack_public_path__ + "static/16-e2afdd0eae8a139d5aa83d6a40cacf8d.jpg";